import React from "react";
import { Button } from "@components";
import { SchemaForm } from "@components";
import type { EditModals } from "./types";

const AddModal = (props: EditModals) => (
  <SchemaForm
    schema={props.schema}
    formData={{}}
    onSubmit={props.onSubmit}
    validate={props.validate}
    uiSchema={props.uiSchema}
  >
    <div className="d-flex justify-content-center pt-5">
      <Button color="secondary" className="w-25 mr-5" onClick={props.onCancel}>
        {props.t("CANCEL")}
      </Button>
      <Button type="submit" className="w-50">
        {props.t("ADD_NEW_DEPARTMENT")}
      </Button>
    </div>
  </SchemaForm>
);

export default AddModal;
